import { useEffect, useState } from "react";
import { brand } from "../../../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { cacheDatabase } from "@/api/firebase/firebase.config";
import { pickerWinnersCriteria } from "../pickedWinnersCriteria";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";

type WinnerData = {
  data: any;
  realtimeDocumentID: string;
};

export const usePickedWinnerUserData = () => {
  const [data, setData] = useState<WinnerData[] | null>(null);
  const currentUser = useCurrentUserProfile((s) => s.user);

  useEffect(() => {
    const tenantId = brand.tenantId || "";
    const criteria = pickerWinnersCriteria[tenantId];

    if (!criteria) {
      console.warn(`No criteria found for tenant: ${tenantId}`);
      return;
    }

    const listeners: Array<() => void> = [];

    const fetchAllChallenges = async () => {
      for (const challengeId of criteria.validChallengeIds) {
        const ref = cacheDatabase
          .ref("picked-winners")
          .child(tenantId)
          .child(challengeId)
          .child(currentUser.uid);

        const listener = ref.on("value", (snapshot) => {
          const challengeData = snapshot.val();

          if (challengeData) {
            // if (challengeData.collected === true) {
            //   setData(null);
            //   return null;
            // }
            const isValidChallenge = criteria.validChallengeIds.includes(
              challengeData.challengeSlug
            );
            const isValidEntry = criteria.validEntrys.includes(
              challengeData.entryNumber
            );

            if (isValidChallenge && isValidEntry) {
              //   return challengeData;
              setData(challengeData); // Update state with new batch
            }
            return null;
          }
        });

        listeners.push(() => ref.off("value", listener));
      }
    };

    fetchAllChallenges();

    return () => {
      listeners.forEach((unsubscribe) => unsubscribe());
    };
  }, []);

  return { data } as const;
};
